import groq from 'groq'
import pageFields from '../fields/page'
import imageField from '../fields/image'
import link from '../fields/link'

export default id => groq`
  *[_id == "${id}" || (_type == "whatsInside" && !defined(version))][0]{
    ...${pageFields},
    introTitle,
    introText,
    productCategorySections[] {
      heading,
      description,
      image,
      "backgroundColors": backgroundColors[].hex,
      productCategory-> {
        _type,
        cbd,
        title,
        "backgroundColors": backgroundColors[].hex,
        "slug": slug.current,
        "ingredients": products[0]->ingredients[]->{
          _id,
          cbd,
          title,
          description,
          image {
            ...${imageField}
          }
        }
      }
    },
    "relatedLinksSection": {
      "heading": relatedLinksHeading,
      "links": relatedLinks[] {
        ...${link}
      }
    }
  }
`
